<template>
  <!-- ════ FOOTER ════ -->
  <footer>
    <div class="footer-top">
      <div class="footer-logo">
        <img src="https://snippcheck.blob.core.windows.net/files/WKKC_Golden_Ticket_2008937/images/logo-lockup.png" alt="Kellogg's Cocoa Loops × Wonka">
        <a href="https://www.wkkellogg.com/where-to-buy#/US/any/products/~/~?dtr-selectedFilter={%22tags%22:%22Froot%20Loops%22}"
          target="_blank" rel="noopener" class="btn-gold footer-buy">Where to Buy<svg class="btn-icon" width="15"
            height="15" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M2.5 8H13M9.5 4.5L13 8L9.5 11.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round"></path>
          </svg></a>
      </div>
      <div class="footer-nav">
        <a href="http://snipp.us/!cuYpr" target="_blank" rel="noopener">Official Rules</a>
        <a href="javascript:void(0)" class="js-pd-open" data-pd-tab="grand">Prize Details</a>
        <a href="javascript:void(0)" class="js-pp-open">Participating Products</a>
        <a href="https://www.wkkellogg.com/contact-us" target="_blank" rel="noopener">Contact Us</a>
        <a nohref='nohref' class='track ot-sdk-show-settings' style='cursor: pointer'>Cookie Preferences</a>
        <a href="https://www.wkkellogg.com/privacy-notice" target="_blank" rel="noopener">Privacy Notice</a>
        <a href="https://www.wkkellogg.com/us-privacy-notice" target="_blank" rel="noopener">USA Privacy</a>
        <a href="https://www.wkkellogg.com/usage-terms" target="_blank" rel="noopener">Terms of Use</a>
        <a href="https://www.wkkellogg.com/do-not-share-or-sell-my-personal-information" target="_blank"
          rel="noopener">Do Not Sell or Share My Personal Information</a>
        <a href="https://www.wkkellogg.com/accessibility" target="_blank" rel="noopener">Accessibility</a>
      </div>
      <div class="footer-social">
        <span class="footer-social-label">Follow Us</span>
        <div class="footer-social-icons">
          <a href="https://www.instagram.com/frootloops" target="_blank" rel="noopener" aria-label="Instagram"><img
              src="https://snippcheck.blob.core.windows.net/files/WKKC_Golden_Ticket_2008937/images/instagram.png" alt="Instagram"></a>
          <a href="https://x.com/frootloops" target="_blank" rel="noopener" aria-label="X"><img
              src="https://snippcheck.blob.core.windows.net/files/WKKC_Golden_Ticket_2008937/images/x.png" alt="X"></a>
          <a href="https://www.facebook.com/frootloops" target="_blank" rel="noopener" aria-label="Facebook"><img
              src="https://snippcheck.blob.core.windows.net/files/WKKC_Golden_Ticket_2008937/images/facebook.png" alt="Facebook"></a>
          <a href="https://www.youtube.com/c/FrootLoops" target="_blank" rel="noopener" aria-label="YouTube"><img
              src="https://snippcheck.blob.core.windows.net/files/WKKC_Golden_Ticket_2008937/images/youtube.png" alt="YouTube"></a>
        </div>
      </div>
    </div>
  </footer>
  <div class="legal-band">
    <p>[FPO Abbreviated Rules] No Purchase Necessary. Begins 8/15/26 and ends 1/18/27. Must be a legal resident of 50
      U.S./D.C., 18+. Receipts must be received no later than 1/18/27. For details on how to enter without making a
      purchase, prize details, odds of winning and complete Official Rules, go to www.wkkellogg.wonka.com.<br><br>© 2026
      WK Kellogg Co. All Rights Reserved.</p>
  </div>
</template>

<script>
//Younet chatbot code apprended in the body
export default {
  mounted() {
    // // Dynamically fetch the translated modelHash
    // const modelHash = this.$t('YounetmodelHash');
    // const modelImgurl = this.$t('YounetmodelIMg');
    // const scriptUrl = `https://widget.younet.ai/index.js?modelHash=${modelHash}&type=bubble&imgUrl=${modelImgurl}`;

    // // Dynamically create the script element
    // const script = document.createElement('script');
    // script.type = 'module';
    // script.src = scriptUrl;

    // // Append the script to the body
    // document.body.appendChild(script);
  },
};
// Mobile nav (hamburger)
(function () {
  const toggle = document.querySelector('.nav-toggle');
  const menu = document.getElementById('mobile-menu');
  if (!toggle || !menu) return;
  function setOpen(open) {
    toggle.classList.toggle('open', open);
    menu.classList.toggle('open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
  }
  toggle.addEventListener('click', () => setOpen(!menu.classList.contains('open')));
  menu.querySelectorAll('a').forEach(a => a.addEventListener('click', () => setOpen(false)));
  document.addEventListener('keydown', e => { if (e.key === 'Escape') setOpen(false); });
  window.addEventListener('resize', () => { if (window.innerWidth > 900) setOpen(false); });
  // Frost the nav bar only after the page is scrolled (transparent at top on load).
  const nav = document.querySelector('.main-nav');
  const onNavScroll = () => { if (nav) nav.classList.toggle('scrolled', window.scrollY > 8); };
  onNavScroll();
  window.addEventListener('scroll', onNavScroll, { passive: true });
})();
</script>


